import { render, staticRenderFns } from "./OrderCustomerEdit.vue?vue&type=template&id=2b7b1378&scoped=true&"
import script from "./OrderCustomerEdit.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b1378",
  null
  
)

export default component.exports